/**
 * @author Rahul Nainala
 * @description This Component is used for rendering the custom Hierarchy's Table
 */
import moment from 'moment-timezone';
import { Button, Input, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { getModuleList, canEditModule } from './apicalls';
import StyledTable from "../../../../commons/styles/table";
import { StyledHomepage } from '../../../../commons/styles/layout';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import translation from "../../../../commons/translation";

const Homepage = (props) => {
  const { translationCache } = props;
  const [moduleData, setModuleData] = useState([]);
  const [editabilityMap, setEditabilityMap] = useState({});
  const [searchText, setSearchText] = useState('');
  let searchInputRef = useRef(null);

  useEffect(() => {
    try {
      const fetchModuleData = async () => {
        try {
          const data = await getModuleList();
          setModuleData(data);
          const editabilityPromises = data.map(async (module) => {
            const canEdit = await canEditModule(module.Code);
            return { code: module.Code, canEdit };
          });
          const editabilityResults = await Promise.all(editabilityPromises);
          const editabilityMap = {};
          editabilityResults.forEach(({ code, canEdit }) => {
            editabilityMap[code] = canEdit;
          });
          setEditabilityMap(editabilityMap);
        } catch (error) {
          message.error('API Error', error);
        }
      };
      fetchModuleData();
    } catch (e) {
      message.error('Module fetch Error ', e);
    }
  }, []);

  const editButtonClick = (value) => {
    props.navigate(`/rubus/editAssets/${value.Id}`);
  };

  const viewButtonClick = (value) => {
    props.navigate(`/rubus/viewAssets/${value.Id}`);
  };
const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(translationCache, 'Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  const ModuleColumns = [
    {
      title: 'Module Name',
      dataIndex: 'Name',
      key: 'Name',
      filter: true,
      ...getColumnSearchProps('Name')

    },
    {
      title: 'Code',
      dataIndex: 'Code',
      key: 'Code',
      filter: true,
      ...getColumnSearchProps('Code')
    },
    {
      title: 'Created By',
      dataIndex: 'CreatedBy',
      key: 'CreatedBy',
      filter: true,
      ...getColumnSearchProps('CreatedBy')
    },
    {
      title: 'Created Date',
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
      render: (text) => <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : null}</span>
    },
    {
      title: 'Action',
      key: 'Action',
      render: (text, record) => (
        <span>
          {editabilityMap[record.Code] ? (
            <Button
              type='primary'
              style={{ marginRight: '5px' }}
              
              onClick={() => viewButtonClick(record)}
            >
              View
            </Button>
          ) : (
            <Button
              type='primary'
              style={{ marginRight: '5px' }}
              onClick={() => editButtonClick(record)}
              
            >
              Edit
            </Button>
          )}
        </span>
      )
    }
  ];

  return (
    <StyledHomepage>
      <StyledTable size="small" columns={ModuleColumns} dataSource={moduleData} key={moduleData.Id} />
    </StyledHomepage>
  );
};

export default Homepage;
